import { Loader } from 'components/UI/loader/loader';
import styles from './_payment.module.scss';

interface Props {
  showLoader: boolean;
}

export const PaymentLoader = ({ showLoader }: Props) => {
  if (!showLoader) return null;
  return (
    <div className={styles.PaymentLoader}>
      <Loader className={styles.PaymentLoader__spinner} />
    </div>
  );
};
